import { render, staticRenderFns } from "./CanteenIndexConfigDetail.vue?vue&type=template&id=21750fb0&scoped=true&"
import script from "./CanteenIndexConfigDetail.vue?vue&type=script&lang=ts&"
export * from "./CanteenIndexConfigDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CanteenIndexConfigDetail.vue?vue&type=style&index=0&id=21750fb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21750fb0",
  null
  
)

export default component.exports